import script from "./BatchDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./BatchDetails.vue?vue&type=script&setup=true&lang=ts"

import "./BatchDetails.vue?vue&type=style&index=0&id=1917dd53&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1917dd53"]])

export default __exports__